const SEARCH_ABBREVIATIONS_MAP = new Map([['webdriverio', 'WDIO']]);

/**
 * Preprocesses search values to handle multiple backend storage formats.
 *
 * Handles cases where:
 * - Backend stores "XCUI" but UI shows "XCUI SDK"
 * - Backend stores "WDIO_MOBILE" but UI shows "WebdriverIO SDK"
 *
 * Generates variants:
 * - Original value: "Best Practice"
 * - With underscores: "Best_Practice"
 * - No spaces: "BestPractice"
 * - SDK mappings (if enabled): "WDIO_MOBILE", "WDIO"
 *
 * @param searchValue - The original search string from user input
 * @param includeSdkMappings - Whether to include SDK-specific name mappings (for Mobile SDK only)
 * @returns Array of search value variants to try
 */
export const preprocessSearchValue = (
	searchValue: string,
	includeSdkMappings = false
): string[] => {
	if (!searchValue) {
		return [];
	}

	const searchVariants = new Set<string>();

	searchVariants.add(searchValue);
	searchVariants.add(searchValue.replace(/\s+/g, '_')); // "Best Practice" -> "Best_Practice"
	searchVariants.add(searchValue.replace(/\s+/g, '')); // Remove all spaces

	// Handle name abbreviations
	if (includeSdkMappings) {
		const lowerSearch = searchValue.toLowerCase();
		for (const [key, value] of SEARCH_ABBREVIATIONS_MAP) {
			if (lowerSearch.includes(key)) {
				searchVariants.add(value);
			}
		}
	}

	return [...searchVariants];
};
